// extracted by mini-css-extract-plugin
module.exports = {"layout":"ThreeColumnLayout-module--layout--1XW5u"};